<template>
  <div class="wishlist" ref="wishlist_container" v-if="displayWishlist">
    <button class="wishlist__add-button" type="button" @click="handleWishlistToggle">
      <i class="wishlist__heart" :class="{ 'wishlist__heart--bouncing': isBouncing }">
        <svg v-if="inWishlist" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          viewBox="-68 169 538 448" style="enable-background:new -68 169 538 448;" xml:space="preserve">
        <g>
          <g>
            <path fill="#FFB400" d="M416.7,223.5C391.5,198,356.8,184,319,184c-52.9,0-93.7,25.5-118,73.7C176.7,209.4,135.9,184,83,184
              c-37.8,0-72.5,14-97.7,39.5C-41.1,250.2-55,286.8-55,329.2c0,51,32.4,107,96.2,166.6c57.9,54,121.3,92,133.5,99
              c5.1,2.9,16.3,9.4,16.3,9.4l4.2,2.4c3.6,2.1,8,2.1,11.6,0l4.2-2.4c0,0,11.2-6.5,16.3-9.4c12.1-7.1,75.6-45,133.5-99
              c63.9-59.6,96.2-115.7,96.2-166.6C457,286.8,443.1,250.2,416.7,223.5z"/>
          </g>
        </g>
        </svg>
        <svg v-if="!inWishlist" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          viewBox="-68 169 538 448" style="enable-background:new -68 169 538 448;" xml:space="preserve">
        <g>
          <g>
            <path fill="#48494D" d="M416.7,223.5C391.5,198,356.8,184,319,184c-52.9,0-93.7,25.5-118,73.7C176.7,209.4,135.9,184,83,184
              c-37.8,0-72.5,14-97.7,39.5C-41.1,250.2-55,286.8-55,329.2c0,51,32.4,107,96.2,166.6c57.9,54,121.3,92,133.5,99
              c5.1,2.9,16.3,9.4,16.3,9.4l4.2,2.4c3.6,2.1,8,2.1,11.6,0l4.2-2.4c0,0,11.2-6.5,16.3-9.4c12.1-7.1,75.6-45,133.5-99
              c63.9-59.6,96.2-115.7,96.2-166.6C457,286.8,443.1,250.2,416.7,223.5z M333.5,466.6c-54.8,51.1-114.8,87-126.3,93.7
              c-0.1,0.1-0.2,0.1-0.4,0.2c-3.6,2.1-8,2.1-11.6,0c-0.1-0.1-0.3-0.1-0.4-0.2c-11.5-6.7-71.5-42.6-126.3-93.7
              C13.9,415.6-15,368.1-15,329.2c0-62,40.3-105.3,98-105.3c37.5,0,64.3,16.6,81.8,50.8c10.8,21,14.5,42.6,15.7,51.7
              c0.4,3.1,1.5,6,3.2,8.6l0,0c8.1,12.4,26.3,12.4,34.5,0l0-0.1c1.7-2.6,2.8-5.5,3.2-8.6c1.2-9,4.9-30.1,15.2-50.7
              c17.3-34.4,44.9-51.8,82.3-51.8c57.7,0,98,43.3,98,105.3C417,368.1,388.1,415.6,333.5,466.6z"/>
          </g>
        </g>
        </svg>
      </i>
    </button>
  </div>
</template>

<style scoped lang="scss">
.single-box__wishlist .wishlist__heart svg {
  width: 2.6rem;
  height: 2.5rem;
}

.wishlist__heart--bouncing {
  animation: bounce 0.5s;
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-5px);
  }
}
</style>

<script>
export default {
  name: "KaaliWishlist",
  props: {
    productId: {
      type: Number,
      required: true
    },
    inWishlist: {
      type: Boolean,
      required: true
    },
    selectedPackage: {
      type: String
    },
    regularPrice: {
      type: Number
    },
    salePrice: {
      type: Number
    },
    quantity: {
      type: Number
    }
  },
  data() {
    return {
      isBouncing: false,
      displayWishlist: ws_vue_store.display_wishlist === "1",
      translations: {
        addToWishlist: ws_vue_store.translations.add_to_wishlist,
        removeFromWishlist: ws_vue_store.translations.remove_from_wishlist
      }
    };
  },
  methods: {
    async handleWishlistToggle() {
      this.isBouncing = true;

      await this.$store.dispatch('toggleWishlist', {
        product_id: this.productId,
        quantity: this.quantity,
        package: this.selectedPackage,
        price: this.salePrice ? this.salePrice : this.regularPrice
      });

      setTimeout(() => {
        this.isBouncing = false;
      }, 1500);
    }
  }
};
</script>